import React, { useEffect, useRef } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

import Navigation from './components/Navigation';
import HomePage from './components/HomePage';
import PropertyPage from './components/PropertyPage';
import PropertiesIndex from './components/PropertiesIndex';
import Footer from './components/Footer';
import { useContactTracking } from './analytics';

// Al cambiar de página con un enlace interno, vuelve arriba. En la carga inicial no
// toca el scroll, para respetar anclas como /#contact.
function ScrollToTop() {
  const { pathname } = useLocation();
  const previous = useRef(pathname);

  useEffect(() => {
    if (previous.current !== pathname) {
      window.scrollTo(0, 0);
      previous.current = pathname;
    }
  }, [pathname]);

  return null;
}

function App() {
  useContactTracking();

  useEffect(() => {
    const prevent = (e) => {
      if (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO') {
        e.preventDefault();
      }
    };
    document.addEventListener('contextmenu', prevent);
    document.addEventListener('dragstart', prevent);
    return () => {
      document.removeEventListener('contextmenu', prevent);
      document.removeEventListener('dragstart', prevent);
    };
  }, []);

  return (
    <div className="App">
      <ScrollToTop />
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/propiedades" element={<PropertiesIndex />} />
        <Route path="/propiedades/:slug" element={<PropertyPage />} />
        <Route path="*" element={<PropertyPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
